export const firebaseConfig = {
  apiKey: "AIzaSyBxn9cb0YkSrDpfEwZdWCLIlwfpXTERVdk",
  authDomain: "zmdesign-8c7c9.firebaseapp.com",
  databaseURL: "https://zmdesign-8c7c9.firebaseio.com",
  projectId: "zmdesign-8c7c9",
  storageBucket: "zmdesign-8c7c9.appspot.com",
  messagingSenderId: "220616679358",
  appId: "1:220616679358:web:922d5c50c13d2056e763ef",
};
